import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { MapPageFor } from "../../../../utils/Enum.types";
import {  GetDataForMapsResult } from "../masters/items/queries/types";

import MapsView from "./MapsView";
import { AtsSubsidiarySiteEdge } from "../masters/subsidary/queries/types";
import { StateTypes } from "./Maps";
import { TableType } from "../../customer/companies/queries/types";

export interface MapProps {
  items: GetDataForMapsResult[];
  sub_sites: AtsSubsidiarySiteEdge[];
  clusterer: React.MutableRefObject<MarkerClusterer | null>;
  pageFor: MapPageFor;
  selectedPlace: google.maps.places.PlaceResult | null;
  setAssetdetails: React.Dispatch<React.SetStateAction<StateTypes>>;
  setRaisedTicketDetails: React.Dispatch<React.SetStateAction<StateTypes>>;
  assetType:TableType;
  setJunctionLevelRaisedTicketModal: React.Dispatch<React.SetStateAction<StateTypes>>;
  searchCoordinates: string
}
const MyMaps = ({ ...props }: MapProps) => {
  return (
    <div className="maps__flex--right--image">
      <MapsView {...props} />
    </div>
  );
};

export default MyMaps;
